//#region ELECTRICITY
export class CreateElectricityMeterConsumption {
    date: Date | string;
    offPeak: number;
    peak: number;
    standard: number;
    invoiceId?: string;
    superOffPeak?: number;

    constructor(
        date: Date | string,
        offPeak: number,
        peak: number,
        standard: number,
        invoiceId?: string,
        superOffPeak?: number
    ) {
        this.date = date;
        this.offPeak = offPeak;
        this.peak = peak;
        this.standard = standard;
        this.invoiceId = invoiceId;
        this.superOffPeak = superOffPeak;
    }

}

export interface ElectricityMeterConsumption {
    date: Date;
    electricityMeterId: number;
    id: number;
    offPeak: number;
    peak: number;
    standard: number;
    superOffPeak?: number;
    totalCost: number;
}

// #region NATURAL GAS
export class CreateNaturalGasMeterConsumption {
    date: Date | string;
    consumption: number;

    constructor(
        date: Date | string,
        consumption: number
    ) {
        this.date = date;
        this.consumption = consumption;
    }

}

export interface NaturalGasMeterConsumption {
    date: Date;
    naturalGasMeterId: number;
    id: number;
    consumption: number;
    totalCost: number;
}